import { CandidateQualifModel } from "./candidate-qualification.model";

export const ICandidateFamilyQualif = Object.freeze({
  familyName: "family_name",
  qualifications: "qualifications",
});

export class CandidateFamilyQualifModel {
  constructor(data = {}) {
    this[ICandidateFamilyQualif.familyName] = data[ICandidateFamilyQualif.familyName];
    this[ICandidateFamilyQualif.qualifications] = data[ICandidateFamilyQualif.qualifications];
  }

  getFamilyName() {
    return this[ICandidateFamilyQualif.familyName];
  }

  getQualifications() {
    return (this[ICandidateFamilyQualif.qualifications] || []).map((qualif) => new CandidateQualifModel(qualif));
  }
}
